import { Injectable } from '@angular/core';

@Injectable()
export class DetailViewerInfoService {
    constructor() {}
    getViewDetailsProperties()
    {
        
        const viewDetailsProperties: Array<any>[]=
        [
        [ 
            { key: 'RTN', type:'label', tooltip: 'Release Tracking Number: Region # followed by unique 7 digit number.', label:"Site Number", width: 'col-md-7'},
            { key: 'Category', type:'label',tooltip: 'How quickly a release must be reported to DEP, dependent on the potential severity of a release.', label:"Category",  width: 'col-md-5'}
        ],
        [ 
            { key: 'SiteName', type:'label',tooltip: 'Describes the site in terms of its location, use, or type.',  label:"Site Name", width: 'col-md-7'},
            { key: 'AUL', type:'customAULlabel', tooltip: 'AUL Details',  label:"AUL Info",  width: 'col-md-5'},
        ],
        [
            { key: 'ComplianceStatus', type:'label', tooltip: "Status of Compliance within 21E.", label:"Regulatory Status",  width: 'col-md-7'},
            { key: 'Address', type:'label', tooltip: "The number and street that most accurately describe the site/release location.", label:"Address",  width: 'col-md-5'}
        ],
        [
            { key: 'Date', type:'labelWithDate', tooltip: "The date a release/site was listed as its current compliance status.", label:"Regulatory Date",  width: 'col-md-7'},
            { key: 'TownName', type:'label', tooltip: "The city and town where the release of oil or hazardous material occurred. Boston and Barnstable are also broken down by neighborhood or village.", label:"Town",  width: 'col-md-5'}
        ],
        [
            { key: 'Phase', type:'label', tooltip: "Indicates which part of the phased MCP cleanup process the release/site is in", label:"Phase",  width: 'col-md-7'},
            { key: 'ZipCode', type:'label', tooltip: "Zip Code", label:"Zip Code",  width: 'col-md-5'}
        ],
        [
            { key: 'RAOClass', type:'label', tooltip: "Classification of site/release where a Permanent or Temporary Solution Statement (formerly RAO Statement) was submitted.", label:"RAO Class",  width: 'col-md-7'},
            { key: 'NotificationDate', type:'labelWithDate', tooltip: "Official notification date of release.", label:"Official Notification Date",  width: 'col-md-5'}
        ],
        [
            { key: 'LocationType', type:'label', tooltip: "Type of property where the site is located. (Residence, Junkyard, Industrial, Roadway, etc.)", label:"Location Type",  width: 'col-md-7'},
            { key: 'InitailStatusDate', type:'labelWithDate', tooltip: "Usually one-year after the earliest date of release notification.", label:"Initial Status Date",  width: 'col-md-5'}
        ],
        [
            { key: 'SourceName', type:'label', tooltip: "Source of contamination.(Drum, Tanker Truck, Hose, etc.)", label:"Source",  width: 'col-md-7'},
            { key: 'pipReceived', type:'labelWithDate', tooltip: "Date the Department received a Public Involvement Petition for the RTN", label:"PIP Received",  width: 'col-md-5'}
        ]
        ]
        return viewDetailsProperties;
    }

    getResponseActionInformationProperties()
    {
        
        const responseActionInformationProperties: Array<any>[]=
        [
        [ 
            { key: 'responseActionInformation', label: 'Response Action Information', iterable: true, modal: false, required: false,
            items : [{ key: 'RESPONSE ACTION TYPE', type: 'text' },
            { key: 'STATUS', type: 'text' },
            { key: 'SUBMITTAL DATE',   type: 'text' },
            { key: 'RAO CLASS',   type: 'text' },
            { key: '	ACTIVITY & USE LIMITATION DATE',   type: 'text' }
            ]
            }
        ]
        ]
        return responseActionInformationProperties;
    }

    getChemicalProperties()
    {
        
        const chemicalProperties: Array<any>[]=
        [
        [ 
            { key: 'responseChemicals', label: 'Chemicals', iterable: true, modal: false, required: false,
            items : [{ key: 'CHEMICAL', type: 'text' },
            { key: 'AMOUNT', type: 'text' },
            { key: 'UNITS',   type: 'text' }
            ]
            }
        ]
        ]
        return chemicalProperties;
    }

    getLSPProperties()
    {
        
        const lspProperties: Array<any>[]=
        [
        [ 
            { key: 'responseLSP', label: 'LSPs', iterable: true, modal: false, required: false,
            items : [{ key: 'LSP', type: 'text' },
            { key: 'LSP NUMBER', type: 'text' }
            ]
            }
        ]
        ]
        return lspProperties;
    }

    getRAODetailProperties()
    {
        
        const roaDetailProperties: Array<any>[]=
        [
        [ 
            { key: 'responseRAODetail', label: 'RAO Detail', iterable: true, modal: false, required: false,
            items : [{ key: 'CLASS', type: 'text' },
            { key: 'METHOD', type: 'text' },
            { key: 'GW CATEGORY', type: 'text' },
            { key: 'SOIL CATEGORY', type: 'text' }
            ]
            }
        ]
        ]
        return roaDetailProperties;
    }

    getTierClassificationDetailProperties()
    {
        
        const tierClassificationDetailProperties: Array<any>[]=
        [
        [ 
            { key: 'responseTierClassificationDetail', label: 'Tier Classification Detail', iterable: true, modal: false, required: false,
            items : [{ key: 'NRS TOTALS', type: 'text' },
            { key: 'II', type: 'text' },
            { key: 'III', type: 'text' },
            { key: 'IV', type: 'text' },
            { key: 'V', type: 'text' },
            { key: 'VI', type: 'text' },
            { key: 'ZONE 2', type: 'text' },
            { key: 'IMMINENT HAZARD', type: 'text' }
            ]
            }
        ]
        ]
        return tierClassificationDetailProperties;
    }

    getSecondaryRTNProperties()
    {
        
        const secondaryRTNProperties: Array<any>[]=
        [
        [ 
            { key: 'responseSecondaryRTN', label: 'Secondary RTNs', iterable: true, modal: false, required: false,
            items : [{ key: 'SECONDARY RTNS', type: 'text' }
            ]
            }
        ]
        ]
        return secondaryRTNProperties;
    }

    getRelatedRTNProperties()
    {
        
        const relatedRTNProperties: Array<any>[]=
        [
        [ 
            { key: 'responseRelatedRTN', label: 'Related RTNs', iterable: true, modal: false, required: false,
            items : [{ key: 'PRIMARY RTN', type: 'text' },
            { key: 'SECONDARY RTN', type: 'text' }
            ]
            }
        ]
        ]
        return relatedRTNProperties;
    }
}
